import { Injectable } from '@angular/core';
import { DefaultService, PowerSupply } from '@psnb/psnb-api';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyListService {
  private _showProgressBar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private jsonPSList: PowerSupply[];

  public constructor(private powerSupplyService: DefaultService) {}

  public get showProgressBar$(): BehaviorSubject<boolean> {
    return this._showProgressBar$;
  }

  public setShowProgressBar(value: boolean): void {
    this._showProgressBar$.next(value);
  }

	public get getJsonPSList(): PowerSupply[] {
		return this.jsonPSList;
	}

	public set setJsonPSList(value: PowerSupply[]) {
    this.jsonPSList = new Array<PowerSupply>();
		this.jsonPSList = value;
	}

	public getPowerSupplyList(parms: {
    address: string;
		distance: number;
    headendOrCommunity: string;
    latitude: number;
    longitude: number;
    macAddress: string;
    node: string;
    nodeCommunintyServed: string;
    nodeId: number;
    nodeText: string;
    powerSupplyId: number;
    powerSupplyName: string;
    regionId: number;
  }): Observable<Array<PowerSupply>> {
    return this.powerSupplyService.searchPowerSupplies(
      parms.powerSupplyName, parms.node, parms.nodeCommunintyServed, parms.nodeId, parms.macAddress, parms.address,
      parms.latitude, parms.longitude, parms.distance, parms.headendOrCommunity, parms.regionId, parms.powerSupplyId,
      parms.nodeText
    )
      .pipe(map((res: PowerSupply[]): PowerSupply[] => res));
	}

	public searchPowerSupplyByHieExport(hieId: number[]): Observable<Blob> {
		return this.powerSupplyService.searchPowerSupplyByHieExport(hieId).pipe(map((res: Blob): Blob => res));
	}
}

